export const AT_EXPLORE_BASE_URL = 'https://atexplore.social'

export const AT_EXPLORE_ENDPOINTS = {
    atProfile: (identifier: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}/app.bsky.actor.profile/self`,
    atDidDoc: (identifier: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}`,
    atStats: (identifier: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}/stats`,
    atMackinacProfile: (identifier: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}/social.mackinac.actor.profile/self`,
    atCollection: (identifier: string, collection: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}/${encodeURIComponent(collection)}`,
    atRecord: (identifier: string, collection: string, rkey: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/at/${encodeURIComponent(identifier)}/${encodeURIComponent(collection)}/${encodeURIComponent(rkey)}`,
    atBlob: (identifier: string, cid: string, preset?: 'avatar' | 'banner') =>
        `${AT_EXPLORE_BASE_URL}/${encodeURIComponent(identifier)}/blob/${cid}${preset ? `?preset=${preset}` : ''}`,
    apProfile: (handle: string) =>
        `${AT_EXPLORE_BASE_URL}/api/explore/ap/${encodeURIComponent(handle)}/profile`,
    cacheInvalidate: `${AT_EXPLORE_BASE_URL}/api/explore/at/cache/invalidate`,
} as const

/** Feed image thumbnail via Bluesky CDN (provides server-side resizing) */
export function feedThumbnail(did: string, cid: string): string {
    return `https://cdn.bsky.app/img/feed_thumbnail/plain/${did}/${cid}@jpeg`
}

/** Feed image fullsize via Bluesky CDN */
export function feedFullsize(did: string, cid: string): string {
    return `https://cdn.bsky.app/img/feed_fullsize/plain/${did}/${cid}@jpeg`
}
